module.exports = __webpack_public_path__ + "static/media/005yhkgl.9146fe61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/005yhkgl.jpg
// module id = 629
// module chunks = 0 1